<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <!-- Jobs -->
    <div id="print" class="card-panel-main col-lg-9 mb-5  " style="transform: translateX(-19vw)">

      <div v-show="allProcesses.length" class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <h2 style="font-size: 1.2vw !important;width:15vw;">تعریف شناسنامه فرآیند  </h2>
            </div>
            <form class="needs-validation mt-2 mb-3" novalidate>
              <div class="row">

                <div style="transform: translateY(-1.5vw)" class="hide col-lg-12 mb-3 no_print">
                  <input v-model="searchProcesses" type="text" class="form-control" style="width: 20vw;"
                         placeholder="جستجو بر اساس عنوان و کد  ...">
                </div>
              </div>
              <hr style="transform: translateY(-1.9vw)">

            </form>
            <div style="transform: translateY(-1.5vw)" class="table-responsive">
              <div style="overflow-y: scroll; height: 50vw;" :style="filteredItems.length < 19 ? 'height: auto;' : ''">

              <table v-show="allProcesses.length" class="table table-striped">
                <thead>
                <tr>
                  <th style="width: 1vw;">ردیف</th>
                  <th>عنوان</th>
                  <th style="width: 15vw;">معادل انگلیسی عنوان</th>
                  <th style="width: 7vw;">سطح فرآیند</th>
                  <th>کد</th>
                  <th class="no_print hide" style="width:8vw;">تکمیل شناسنامه</th>
                </tr>
                </thead>
                <tbody >
                <tr v-for="(item,index) in filteredItems"  :style="setcolor(item['type'])">
                  <td scope="row">{{ index + 1 }}</td>
                  <td style="text-align: center">{{ item['title'] }}</td>

                  <td v-if="item['title_en']"> {{ item['title_en'] }}</td>
                  <td v-else>
                    --
                  </td>
                  <td v-if="item['type']">
                    <span v-if="item['type']==1">
                      طبقه
                    </span>
                    <span v-else-if="item['type']==2">گروه</span>
                    <span v-else-if="item['type']==3">فرآیند</span>
                    <span v-else-if="item['type']==4">زیرفرآیند</span>
                  </td>
                   <td v-else>
                    دسته
                  </td><td>{{ item['code'] }}</td>
                  <td >
                    <div class="d-flex align-content-center justify-content-center">
                      <router-link style="font-size: .8vw" class="btn btn-primary btn-approve justify-content-evenly" :to="`/process/id/complete/${item['id']}`">تکمیل / بروزرسانی  </router-link>
                    </div>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>

  <!--  *******************************-->


  <!-- modal  -->

  <!--  *******************************-->
  <!--  *******************************-->


  <!--  *******************************-->
  <!--  *******************************-->

  <!--  *******************************-->
  <!--  *******************************-->

  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="Error" style="z-index: 999999999999999">
    <div>
      <p>خطا</p>
      <p @click="Error=!Error">❌</p>
    </div>
    <div>
      <p>{{ ErrorM }}</p>
      <button @click="Error=!Error">تایید</button>
    </div>
  </div>
  <!-- modal  -->
</template>

<script>
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import router from "@/router";

export default {
  name: "process_map",
  components: {Sidebar, Splash},
  data() {
    return {
      //*******************************
      //*******************************
      // todo: for categories *******************************
      // *******************************
      categories: [],
      nameCat: '',
      shortNameCat: '',
      encodingMethodCat: '',
      level_cardid: '',
      title_en: '',
      subLevelsCat1: '',
      subLevelsCat2: '',
      subLevelsCat3: '',
      subLevelsCat4: '',
      sub_id: 0,
      isValueChainCat: false,
      openModalsubLevelsCat: false,
      // todo: for categories *******************************
      //*******************************
      // *******************************
      Error: false,
      ErrorM: '',
      // *******************************
      // *******************************
      // todo: for Processes *******************************
      allProcesses: [],
      searchProcesses: '',
      ProcessesId: '',
      addParentProcesses: false,
      modalTitleEn: false,
      modalTitleFa: false,
      editModal: false,
      deleteModal: false,
      showMore: false,
      title_for_edit: '',
      title_for_edit_fa: '',
      levelSub: '',
      title_for_edit_en: '',
      itemProcesses: [],
      table_all_Processes: [],
      table_all_Processes_floor: [],
      table_all_Processes_groups: [],
      table_all_Processes_process: [],
      table_all_Processes_sub_process: [],

      title_for_edit_fa_processes: '',
      title_for_edit_en_processes: '',
      levelSub_processes: '',
      //*******************************
      table_all_Processes_by_group: [],
      table_all_Processes_groups_by_group: [],
      table_all_Processes_process_by_group: [],
      table_all_Processes_sub_process_by_group: [],
      //*******************************
      table_all_Processes_by_processes: [],
      table_all_Processes_process_by_processes: [],
      table_all_Processes_sub_process_by_processes: [],
      //*******************************
      table_all_Processes_by_sub_process: [],
      table_all_Processes_sub_process_by_sub_process: [],

      is_floor_select: false,
      is_group_select: false,
      is_process_select: false,
      is_sub_process_select: false,


      // todo: for Processes *******************************
      //*******************************
      //*******************************
      openModalsubLevelsCatForIdCard: false,
      subLevelsCat2_id: '',
      subLevelsCat3_id: '',
      subLevelsCat4_id: '',
      //*******************************
      //*******************************

    };
  },
  methods: {


    setcolor(level) {

      if (parseInt(level) === 2) {
        return `background: #86D1FF !important`

      }


      if (parseInt(level) === 3) {
        return 'background: #bce6ff !important'

      }
      if (parseInt(level) === 4) {
        return 'background: #d9f1ff !important'

      } else {
        return 'background: rgba(#d9f1ff, 40%) !important'
      }


    },




    fetchAllProcesses() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all_for_id`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            if (result.items.length) {
              this.allProcesses.length = 0
              result.items.forEach((ele) => {
                this.allProcesses.push(ele)


              })
            }


          })
          .catch();





    },


    checkIsMother(){

      if (this.is_mother){
        router.push('/mother_items')
        return
      }


    }



  },
  mounted() {
    this.checkIsMother()
    this.fetchAllProcesses()
  },
  computed: {
    filteredItems() {
      return this.allProcesses.filter(item => {
        if (this.searchProcesses) {
          const titleIncludes = item['title'] && item['title'].includes(this.searchProcesses);
          const categoryIncludes = item['category'].includes(this.searchProcesses);
          const code = item['code'].includes(this.searchProcesses);

          return titleIncludes || categoryIncludes || code;
        } else {
          return true; // در صورتی که searchProcesses خالی باشد، همه موارد نمایش داده شوند.
        }
      });
    },

  }

}
</script>

<style scoped>
.row {
  padding: .5vw;
}

@media print {
  .no-print, .hide {
    display: none;
  }
}

</style>